import React, { useState, useEffect } from "react";
import {
    Button,
    Chip,
    colors,
    Container,
    Dialog,
    Grid,
    Hidden,
    makeStyles,
    Paper,
    Typography,
} from "@material-ui/core";
import useFetchURL from "../../../../../components/Hooks/useFetchURL";
import { uri } from "../../../../../help/Api";
import { useHistory } from "react-router-dom";
import {
    useStylesHed,
    useStylesSpDial,
    useStylesUiElemment,
} from "../../../../../St/comps/UseStyle";
import ScannerIcon from "@material-ui/icons/Scanner";
import KeyboardReturnSharpIcon from "@material-ui/icons/KeyboardReturnSharp";
import PrintIcon from "@material-ui/icons/Print";
import { useTranslation } from "react-i18next";
import BeatLoader from "react-spinners/BeatLoader";
import i18next from "i18next";
import { TableChart } from "@material-ui/icons";
import { CSVLink } from "react-csv";
import moment from "moment";
import axios from "axios";
import OutstandingInvoiceTable from "./OutstandingInvoiceTable";
import OutstandingInvoiceForm from "./OutstandingInvoiceForm";
import { sto } from "../../../../../Context/InshData";

const useStyles = makeStyles((theme) => ({
    root: {
        // backgroundColor: theme.palette.background.dark,
        minHeight: "100%",
        paddingBottom: theme.spacing(3),
    },
    itemW: {
        // display:'flex',
        width: "90%",
    },
    headerTitle: {
        backgroundColor: colors.green[50],
        textAlign: "center",
        fontSize: 20,
        width: "100%",
    },

    allWidth: {
        minWidth: 650,
    },
    checStyl: {
        marginTop: "17px",
        fontSize: "16px",
        padding: "-1px",
    },
    purchTotalCard: {
        backgroundColor: colors.blue[50],
        borderColor: colors.blue[300],
    },
    safesTotalCard: {
        backgroundColor: colors.blue[100],
        borderColor: "#3f51b5",
    },
}));

export default function OutstandingInvoice(props) {
    const { AutoOptions,
        showChosedInvt,
        setting,
        isPurches,
        outstandData,
        setOutstandData
    } = props;

    // let idUser = AutoOptions?.Users[0]?.id;
    // let nameUser = AutoOptions?.Users[0]?.name;
    const initialSearchObject = {
        dateFrom: moment(new Date().setDate(new Date().getDate() - 1)).format("YYYY-MM-DD"),
        timeFrom: moment(new Date()).startOf("day").format("HH:mm"),
        dateTo: moment(new Date()).format('YYYY-MM-DD'),
        timeTo: moment(new Date()).format('HH:mm'),
        // user: { id: sto.User_typei == 1 ? -1 : idUser, name: sto.User_typei == 1 ? 'الكل' : nameUser },
        branch: sto.branchi,
        sales_man: { id: -1, name: "الكل" },
        cust: { id: -1, name: "الكل" },
        bill_no: "",
        isAdmin: sto.User_typei == 1,
        bank: { id: -1, name: "الكل" },
        cust_mobile: "",
        inv_type: { id: -1, name: "الكل" },
        pay_type: { id: -1, name: "الكل" },
        trans_no: -1,
        center: { id: -1, name: "الكل" },
    };

    const [rptParams, setRptParams] = React.useState(initialSearchObject);
    const classes = useStyles();
    const clasui = useStylesUiElemment();
    const clasSp = useStylesSpDial();
    const { t } = useTranslation(["forms", "translation"]);

    // const [data, setData] = useState([]);
    const [fetching, setFetching] = useState(false);

    const viewHandle = async () => {
        setOutstandData([]);
        setFetching(true);
        await axios
        .get(
            uri +
            "InvDatet" +
            `?id=${sto.empi}&&dateF=${rptParams.dateFrom}
            &&dateT=${rptParams.dateTo}
            &&PcIdIvPc=${setting.PrTy_InPr}
            &&uType=${sto.User_typei}
            &&bran=${sto.branchi}`
          )
            .then((res) => {
                setOutstandData(res.data);
                setFetching(false);
            })
            .catch((err) => {
            });


    };

    const his = useHistory();

    const onChangeData = (propName) => (event) => {
        setRptParams({ ...rptParams, [propName]: event.target.value });
    };
    const onChangeAutoData = (propName, newValue) => {
        setRptParams({ ...rptParams, [propName]: newValue });
    };
    return (

            <div className={classes.root}>

                <Typography
                    component="div"
                    style={{ direction: i18next.language == "ar" ? "rtl" : "ltr" }}
                >
                    <Container
                        component={Paper}
                        maxWidth={false}
                        style={{
                            padding: "10px",
                            paddingBottom: "0px",
                            borderBottomColor: isPurches ? colors.blue[300] : colors.green[300],
                            borderBottomWidth: "1px",
                            borderBottomStyle: "solid",
                        }}
                    >
                        <OutstandingInvoiceForm
                            {...{
                                AutoOptions,
                                rptParams,
                                onChangeData,
                                onChangeAutoData,
                                isPurches,
                                viewHandle,
                                fetching
                            }}
                        />

                    </Container>
                    <br />
                    <Container
                        component={Paper}
                        maxWidth={false}
                        style={{
                            paddingRight: "5px",
                            paddingLeft: "5px",
                        }}
                    >
                       <Grid container justifyContent="center">
                                <Grid item container justifyContent="center" xs={12}>
                                    <BeatLoader loading={fetching} color={colors.green[300]} />
                                    {!fetching && (
                                        <OutstandingInvoiceTable
                                            {...{
                                                data: outstandData ? outstandData : [],
                                                showChosedInvt,
                                                viewHandle
                                            }}
                                        />
                                    )}
                                </Grid>
                            </Grid>
                    </Container>
                </Typography>
            </div>
    );
}
